<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .m-t-sm.pull-right(v-show="!onLoading('fetch-stock-receive')")
            .dropdown.inline
                button.md-btn.md-raised.m-b-sm.white.m-r-sm.w-xs.dropdown-toggle(
                    data-toggle="dropdown",
                    :disabled="isLoading",
                    aria-expanded="false"
                ) Action
                .dropdown-menu
                    a.dropdown-item(:href="printUrl", target="_blank")
                        i.material-icons.m-r-sm print
                        | Print

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Stock Receive
                li.breadcrumb-item.active {{ stockReceive.reference_id }}

    .padding(v-show="!onLoading('fetch-stock-receive')")
        stock-receive-info
        stock-receive-stocks

        .box.dker(v-show="!onLoading('fetch-stock-receive')", v-if="!hasFinalized")
            .box-body.text-right
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="isLoading",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green.m-r-sm(
                    :disabled="isLoading",
                    @click="saveChanges",
                    v-if="canEdit"
                )
                    v-loading(loader="save-stock-receive") Save

                button.md-btn.md-raised.m-b-sm.p-r-md.p-l-md.green(
                    :disabled="isLoading",
                    @click="markReceived",
                    v-if="canEdit"
                )
                    v-loading(loader="mark-received") Mark as Received
</template>

<script>
import stockReceiveMixin from './stock-receive-mixin';
import stockReceiveInfo from './stock-receive-edit-info.vue';
import stockReceiveStocks from './stock-receive-edit-stocks.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stockReceiveStocks, stockReceiveInfo },

    mixins: [stockReceiveMixin],

    computed: {
        ...mapGetters('stockReceive', ['stockReceive', 'hasFinalized']),

        isLoading() {
            return (
                this.onLoading('save-stock-receive') ||
                this.onLoading('mark-received') ||
                this.onLoading('fetch-stock-receive')
            );
        },

        printUrl() {
            return Laroute.route('stock_receives.print', {
                id: this.stockReceive.id,
            });
        },
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.getStockReceive(id);
            }

            this.errors.clear();
        },
    },

    created() {
        this.getStockReceive(this.$route.params.id);
    },

    methods: {
        ...mapActions('stockReceive', [
            'getStockReceive',
            'updateStockReceive',
        ]),

        cancel() {
            this.$router.push('/');
        },

        async saveChanges() {
            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updateStockReceive();
                this.swal({ text: 'Stock receive has successfully saved' });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async markReceived() {
            if (!this.stockReceive.stocks.length) {
                this.swalWarning({
                    text: 'You must at least add a stock to proceed.',
                });

                return;
            }

            const validate = await this.validateForm();
            if (!validate) return;

            try {
                await this.updateStockReceive(true);
                this.swal({
                    text: 'Stock receive has successfully mark as shipped',
                });
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        async validateForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }
            }

            return validate;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_receive/stock-receive-edit.vue